import { PackageUnit } from "@/types/type";

// Helper: loại bỏ 'Z' suffix để parse timestamp như local time
// (Backend trả về thời gian đã ở +7 nhưng đánh dấu Z)
export function parseAsLocalTime(date: Date | string): Date {
    if (typeof date === 'string' && date.endsWith('Z')) {
        return new Date(date.slice(0, -1));
    }
    return new Date(date);
}

export function formatDate(date: Date | string): string {
    const d = parseAsLocalTime(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const hour = String(d.getHours()).padStart(2, '0');
    const minute = String(d.getMinutes()).padStart(2, '0');
    return `${hour}:${minute} ${day}/${month}/${year} `;
}

export function formatDateOnly(date: Date | string): string {
    const d = parseAsLocalTime(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
}

export function formatDateTime(date: Date | string): string {
    const d = parseAsLocalTime(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const hour = String(d.getHours()).padStart(2, '0');
    const minute = String(d.getMinutes()).padStart(2, '0');
    const second = String(d.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
}

export function formatCurrency(amount: number): string {
    return amount.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' });
}

export function getPaymentCycle(period: number, unit: PackageUnit): string {
    switch (unit) {
        case PackageUnit.DAY:
            return `${period} ngày`;
        case PackageUnit.MONTH:
            return `${period} tháng`;
        case PackageUnit.YEAR:
            return `${period} năm`;
        default:
            return '';
    }
}

export function calculateExpirationDateByPeriod(period: number, unit: PackageUnit): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expirationDate = new Date(today);

    switch (unit) {
        case PackageUnit.DAY:
            expirationDate.setDate(expirationDate.getDate() + period);
            break;
        case PackageUnit.MONTH:
            expirationDate.setMonth(expirationDate.getMonth() + period);
            break;
        case PackageUnit.YEAR:
            expirationDate.setFullYear(expirationDate.getFullYear() + period);
            break;
        default:
            expirationDate.setDate(expirationDate.getDate() + period);
    }
    return expirationDate;
}

export function getRemainDays(endDate: Date | string): number {
    const now = new Date();
    const end = new Date(endDate);
    const diffTime = end.getTime() - now.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function convertBytesToGB(bytes: number): number {
    return parseFloat((bytes / (1024 * 1024 * 1024)).toFixed(5));
}

export function forceLogout(): void {
    try {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
    } finally {
        window.location.href = '/';
    }
};